import {Component, Input, OnInit} from '@angular/core';
import {HorizontalStackedBarChartData} from './horizontal-stacked-bar-chart-data';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-horizontal-stacked-bar-chart',
  templateUrl: './horizontal-stacked-bar-chart.component.html',
  styleUrls: ['./horizontal-stacked-bar-chart.component.scss']
})
export class HorizontalStackedBarChartComponent implements OnInit {
  @Input() data: Observable<HorizontalStackedBarChartData>;
  processedData: Observable<HorizontalStackedBarChartData>;
  constructor() { }

  ngOnInit() {
    this.processedData = this.data.pipe(
      map(
        data => {
          const processedData: HorizontalStackedBarChartData = Object.assign({}, data);
          const total = data.bars.reduce((sum, bar) => sum + bar.value, 0);
          processedData.overallLabel = data.valueFormatter ? data.valueFormatter(processedData.overall)
            : processedData.overall.toString();
          processedData.bars.forEach(
            bar => {
              if (!bar.title) {
                bar.title = bar.value;
              }
              bar.label = data.valueFormatter ? data.valueFormatter(bar.value) : bar.value.toString();
              bar.widthPercent = (total > 0) ? (Math.round(bar.value / total * 1000) / 10) : 100 / data.bars.length;
            }
          );
          return processedData;
        }
      )
    );
  }

}
